export const GET_NOTIFICATIONS = 'notifications/GET_NOTIFICATIONS';
export const TOGGLE_NOTIFICATION_PANEL =
  'notifications/TOGGLE_NOTIFICATION_PANEL';
export const DELETE_NOTIFICATION = 'notifications/DELETE_NOTIFICATION';
export const EDIT_NOTIFICATION = 'notifications/EDIT_NOTIFICATION';
export const MARK_ALL_AS_READ = 'notifications/MARK_ALL_AS_READ';
